import React from 'react';
import './FMS.css';
import FMSimage from '../Assets/fms222.jpg'; // First image
import FMSimage2 from '../Assets/fuel.jpeg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/FMS.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/IMG-20250523-WA0005[1].jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/fms4.png'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">FUEL MONITORING SYSTEM</h1>
                        <p className="FMS-description">
                            Our Fuel Monitoring System (FMS) is designed to monitor and control fuel consumption with precision. It accurately measures and tracks fuel inventories, monitors dispensing, and provides real-time data to optimize fuel management, reduce fraud, and enhance operational efficiency across various industries.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Fuel Monitoring" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Real-Time Tracking:</strong> Monitors fuel levels, consumption, and refilling in real time.</li>
                                <li><strong>Instant SMS Alerts:</strong> Provides immediate notifications for low fuel, fuel theft, or refilling events.</li>
                                <li><strong>Fraud Detection:</strong> Alerts on fraudulent activities like fuel theft or unauthorized extraction.</li>
                                <li><strong>Fuel Efficiency Reports:</strong> Generates monthly usage and refueling reports for cost-effective decisions.</li>
                                <li><strong>Dashboard Analytics:</strong> Offers an intuitive dashboard for fuel consumption and engine running hours.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            The Fuel Monitoring System uses advanced sensors to track fuel levels and consumption in real time. Data is transmitted wirelessly to a centralized dashboard, providing insights into fuel availability, efficiency, and engine running hours. Instant SMS alerts notify users of low fuel, fuel theft, or refilling events, enabling early intervention. Monthly reports and analytics help optimize operations and prevent misuse.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Fuel Monitoring System</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our FMS delivers unmatched reliability and efficiency, helping businesses save costs and prevent fuel misuse. Key benefits include:
                            <ul>
                                <li>Accurate real-time tracking of fuel levels and consumption</li>
                                <li>Instant SMS alerts for proactive fraud and low-fuel management</li>
                                <li>Comprehensive dashboards and reports for cost-effective decisions</li>
                                <li>Enhanced security to prevent fuel theft and unauthorized use</li>
                                <li>Seamless integration and efficient fuel management</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose Us" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our FMS */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our FMS</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using FMS" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Fuel Monitoring System is trusted by a variety of industries to optimize fuel management and enhance operational efficiency. These industries rely on our solution for its accuracy, reliability, and cost-saving benefits:
                            <ul>
                                <li>Transportation & Logistics</li>
                                <li>Automotive Fleets</li>
                                <li>Construction</li>
                                <li>Manufacturing</li>
                                <li>Agriculture</li>
                                <li>Mining</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FMS;